<template>
    <div id="ficheContact">
        <b-row class="backInfoMain2">

            <s-menuSave 
                :msg="sendMsg" 
                newBtn 
                :btnSaveDisabled="checkAllField" 
                @new="menuNew()" 
                saveBtn 
                @save="menuSave()" 
                :deleteBtn="checkDeleteBtn"
                @delete="menuDelete(activeObj.id)"
                :msgText="sendMsg2"
                :msgType="getTheme.primary">
            </s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                
                    <!--Affichage de la liste-->
                    <s-itemList
                        v-if="contactList"
                        :content="contactList" 
                        :returnValue.sync="activeObj"
                        showField="name" 
                        activeField="isActive" 
                        :selectedItems="activeObj"
                        multiColonne
                        :fields="fields"
                        @getRowdDetail="getRowdDetail"
                        >
                    </s-itemList>
            </b-col>
            <!--Fin section de gauche-->
            
<!--****************************************************************************************************************************************************************-->
            
            <!--Section du centre-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">
                
                <!--INFORMATIONS DU CONTACT-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Informations')}}</div>
                            <div class="itemContain">
                                <!--Nom du contact-->
                                <s-input id = "name" name="name" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('c_Nom')" v-capitalize v-model="activeObj.name" :state="isValid(activeObj.name)"></s-input>
                                <!--Titre du contact-->
                                <s-input id = "title" name="title" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('c_Titre')" v-capitalize v-model="activeObj.title" :state="isValid(activeObj.title)"></s-input>
                                <!--Adresse du contact-->
                                <s-input id = "add" name="add" type="text" maxlength="250" class="MargeTop15" :placeholder="$t('c_Adresse')" v-capitalize v-model="activeObj.address1" :state="isValid(activeObj.address1)"></s-input>
                                <!--Ville du contact-->
                                <s-input id = "city" name="city" type="text" maxlength="40" class="MargeTop5" :placeholder="$t('c_Ville')" v-capitalize v-model="activeObj.city" :state="isValid(activeObj.city)"></s-input>
                                <!--Province & Pays-->
                                <b-row>
                                    <b-col cols="6">
                                        <s-input id = "state" name="state" type="text" maxlength="15" class="MargeTop15" :placeholder="$t('c_Province')" v-model="activeObj.state"></s-input>
                                    </b-col>
                                    <b-col cols="6">
                                        <s-input id = "country" name="country" type="text" maxlength="10" class="MargeTop15" :placeholder="$t('c_Pays')" v-model="activeObj.country"></s-input>
                                    </b-col>
                                </b-row>
                                <!--Télephone, Extension & Code postal-->
                                <b-row>
                                    <b-col cols="4" xl="4">
                                        <s-input id = "tel" name="tel" type="text" maxlength="15" class="MargeTop15" :placeholder="$t('c_Telephone')" v-mask="'(999) 999 9999'" v-model="activeObj.tel" :state="isValid(activeObj.tel)"></s-input>
                                    </b-col>
                                    <b-col cols="4" xl="4">
                                        <s-input id = "telExt" name="telExt" type="text" maxlength="10" class="MargeTop15" :placeholder="$t('c_Ext')" v-model="activeObj.telExt"></s-input>
                                    </b-col>
                                    <b-col cols="4" xl="4">
                                        <s-input id = "zipCode" name="zipCode" type="text" maxlength="7" class="MargeTop15" :placeholder="$t('c_CodePostal')" v-uppercase v-model="activeObj.zipcode"></s-input>
                                    </b-col>
                                </b-row>
                                <!--Courriel-->
                                <s-input id = "email" name="email" type="text" maxlength="40" class="MargeTop5" :placeholder="$t('c_Courriel')" v-model="activeObj.email" :state="isValid(activeObj.email)"></s-input>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>

            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">

                <!--LISTE DES CLIENTS AUXQUELS LE CONTACT EST AFFILIE-->
                <b-row>
                    <b-col cols="12" >
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('c_Clients')}}</div>
                            <div class="itemContain">

                                <b-input-group class="addLicContainer mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                        <b-form-input id="search" name="search" type="text" :placeholder="$t('g_Recherche')" v-model="filterTxt"></b-form-input>

                                    <b-input-group-append is-text class="cursorPoint" @click="filterTxt = ''">
                                        <b-icon icon="x"></b-icon>
                                    </b-input-group-append>
                                </b-input-group>


                                <b-list-group v-if="getClientList?.length > 0" class="scroll borderMain">
                                    <b-list-group-item class="d-flex justify-content-between align-items-center cursorPoint btnStyle"
                                        v-for="(client, index) in getClientList" :key="index" 
                                    >
                                    <span>#{{index+1}}</span>
                                        <span>{{client.clientName}}</span>
                                        <b-badge pill :variant="client.isActive == false ? 'danger' : ''">
                                            <span v-if="client.isActive">{{$t('g_Actif')}}</span>
                                            <span v-else>{{$t('g_Inactive')}}</span>
                                        </b-badge>
                                    </b-list-group-item>

                                </b-list-group>
                                <span v-else>{{$t('g_NoData')}}</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            
            </b-col>
            <!--FIN - Section de droite-->
        </b-row>
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import {dataService} from '@/services'
import store from '@/store'
import SocketioService from '@/plugins/socket/socketio.service.js'
export default{
    name: "ficheContactClient",
    mixins:[mapGetter],
    components: {

    },
    data() {
        return{
            filterTxt : '',
            InitialState: null, //Format initial de : activeObj
            activeObj:{}, //Créé à l'ouverture à partir du modèle vide dans l'api
            originalObj : {},
            fields:[
                {
                    colName: "id",
                    label: "id",
                    show: false,
                },
                {
                    colName: "name",
                    label: this.$i18n.t('c_Nom'),
                    show: true,
                },
                {
                    colName: "title",
                    label: this.$i18n.t('c_Titre'),
                    show: true,
                },
            ], 
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            sendMsg2: 'vide', //message a utiliser pour le menu en haut de la page New/Save/Delete
        
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        /**
         * Reinitialise tous les champs de la fiche contact
         */
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.originalObj = this.$CObj(this.activeObj)
        },
        /**
         * Crée un nouveau fiche contact vide
         */
        menuNew(){
            this.resetAll()
        },
        /**
         * Charge les données des contacts 
         */
        loadApi() {
            if(this.payload.length == 0) {
                //Charger les contacts depuis le serveur si ils ne sont pas présent locallement
                this.sendMsg = '4'
                dataService.getClientContacts()
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        let data = response.data;
                        this.InitialState = this.$CObj(data.addons.classes[0])
                        this.activeObj = this.$CObj(this.InitialState)
                        this.originalObj = this.$CObj(this.InitialState)
                    }
                    this.sendMsg = ''
                    console.log('La liste des contacts (client) est chargée depuis le serveur');
                    
                })
                .catch(error =>{
                    this.sendMsg = ''
                    console.log(error);
                })

            } else {
                //Les données chargées depuis le localStorage
                this.InitialState = this.$CObj(this.payload.addons.classes[0])
                this.activeObj = this.$CObj(this.InitialState)
                this.originalObj = this.$CObj(this.InitialState)
                console.log('La liste des contacts (client) est chargée à partir du client');
            }
        },
        /**
         * Sauvegarde la fiche contact
         */
        menuSave(){
            let t = this.activeObj
            
            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                //this.sendMsg = '-'
                dataService.addClientContact(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg2 ='add Contact OK';
                        this.sendMsg = ''
                        const newAccount = response.data.data
                        SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'clientcontact', payload: newAccount});
                        this.contactList.unshift(newAccount)
                        
                        this.resetAll()
                            
                    } 
                    else {
                        alert('KO')
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if(error.data.data == "") {
                        this.sendMsg2 = error.data.addons.errorFr;
                    }
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                this.sendMsg = '-'

                dataService.updateClientContact(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            this.sendMsg2 ='update OK';
                            const updatedContact = response.data.data
                            SocketioService.getSocket().emit('afterUpdate', {action: 'afterUpdate', storeName:'clientcontact', payload: updatedContact});
                            this.contactList = this.contactList.map(contact => {
                                if(contact.id == updatedContact.id)  Object.assign(contact, updatedContact) ;
                                return contact;
                            });
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = ''
                    console.log(error);
                    alert('update KO');
                });
            }
            setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        /**
         * Désactive la fiche contact
         * @param {int} id - id du contact
         */
        menuDelete(id){
            if (id != '0')
                {
                    this.sendMsg = '-'
                    dataService.deleteClientContact(id)
                    .then((response) => {
                        this.sendMsg = ''
                        if(response.data) {
                            SocketioService.getSocket().emit('afterDelete', {action: 'afterDelete', storeName:'clientcontact', payload: {id:id, isActive:false}});
                            this.contactList = this.contactList.map(contact => {
                                if(contact.id == id)  contact.isActive = !contact.isActive;
                                return contact;
                            });
                            this.resetAll()
                        }
                    })
                    .catch((error) => {
                        this.sendMsg = '';
                        console.log(error);
                    });
                }
        },
        /**
         * Retourne les détails du contact 
         * @param {int} id - id du contact
         */
        getRowdDetail(id)
        {
            this.sendMsg = '-'
            let contact = this.contactList.find(contact => typeof contact !== 'undefined' && contact.id == id);
            
            if(contact)
            {
                this.activeObj = this.$CObj(contact)
                this.sendMsg2 ='getContact OK';
                this.originalObj = this.$CObj(this.activeObj)
                this.InitialState = this.$CObj(this.payload.addons.classes[0])
            }
            this.sendMsg = ''

            /*
            this.sendMsg = '-'
            dataService.getClientContact(id)
            .then((response) => {
                if(response.statusText == 'OK')
                {
                    if(response.data)
                    {
                        let data = response.data.data;
                        this.activeObj = data[0]
                        this.sendMsg2 ='getContact OK';
                        this.originalObj = this.$CObj(this.activeObj)
                        this.InitialState = this.$CObj(response.data.addons.classes[0])
                    }
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = ''
                console.log(error);
                
                if(error.data.data == "") {
                    this.sendMsg2 = error.data.addons.errorFr;
                }
            });
            */
        },
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        /**
         * Vérifie s'il ya une modification
         */
        checkAllField() {
            return JSON.stringify(this.originalObj) === JSON.stringify(this.activeObj)
        },
        /**
         * Vérifie si on autorise la désactivation du contact
         */
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        /**
         * Retourne la liste des clients auxquels le contact est associé
         */
        getClientList() {
            const search = this.filterTxt.toLowerCase().trim();
            var items = this.activeObj.clientList; 
            if (!search) return items;

            var filteredItems = [];
            items.forEach(function(item){
                var keys = Object.keys(item)
                keys.forEach(function(key){
                    if(item[key].toString().toLowerCase().indexOf(search) > -1)
                    {
                        filteredItems.push(item)
                    }
                })
            });
            return [...new Set(filteredItems)]  
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
        payload : () => store.getters.getClientContactsOnClient,
        /**
         * Retourne la liste des contacts du payload
         */
        contactList: {
            get: function() {return this.payload?.data},
            set: function(){}
        }
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi()
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>